import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import SalesOrderAPI from '../../api/SalesOrderAPI';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';

class InsallmentModeList extends React.Component {

  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Const.Model).installment_mode;
    this.modes = model.options;
    this.state = { ...this.state, mode: {}, popup: false, inApiCall: true };
    this.path = this.props.match.path;

    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  show = i => {
    const mode = i === -1 ? { id: 0, name: '' }
      : { id: this.modes[i].value, name: this.modes[i].label };
    this.setState({ ...this.state, mode: mode, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.mode.name.trim().length === 0) return;
    this.setState({ ...this.state, popup: false, inApiCall: true });
    SalesOrderAPI.saveInstallmentMode(this.state.mode, this.success, this.onFail);
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  success = () => {
    Util.showNotification('Successful', `Installment Modes Added successfully.`
      + ` Please reload page to see changes`, 'success');
  };
  nameChange = val => this.setState({ ...this.state, mode: { ...this.state.mode, name: val } });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.modes[index].name}`, 'Delete', 'No',
      () => {
        this.setState({ ...this.state, inApiCall: true });
        SalesOrderAPI.deleteInstallmentMode(this.modes[index].value, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', `Installment Modes Deleted successfully.`
      + ` Please reload page to see changes`, 'success');
  };

  render() {
    if (!this.List) return null;
    const modeUI = this.modes.map((mode, _i) => (
      <tr key={`mode_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{mode.label}</td>
        <td>{mode.paid === Const.True ? Const.Yes : Const.No}</td>
        <td>{Display.ModelLabelValue('user', mode.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(mode.created_date)}</td>
        <td>{Display.ModelLabelValue('user', mode.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(mode.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update
            </div>
          }
          {mode.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete
            </div>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Installment Mode</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Installment Mode Name"
                    className="mr-sm-2"
                    value={this.state.mode.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 pb-3"><h3>Installment Modes</h3></div>
              {this.Add &&
                <div className="col-md-2 text-right pb-3">
                  <div className="success buttons pcat" onClick={() => this.show(-1)}>+ Add</div>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Paid</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {modeUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(InsallmentModeList);